/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { QueueService } from '@/services/v2/queue'

if (process.env.NODE_ENV === 'production') {
  const CACHE_NAME = 'my-cache';

  // Cache static assets on install
  self.addEventListener('install', (event) => {
    event.waitUntil(
      caches.open(CACHE_NAME).then((cache) => {
        return cache.addAll([
          '/',
          '/index.html',
          '/styles.css',
          // Add other static assets to cache
        ]);
      })
    );
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated() {
      console.log('New content is available; please refresh.');
    },
    offline(event) {
      console.log('No internet connection found. App is running in offline mode.');

      // Retrieve and process items from the queue when offline
      QueueService.getAllFromQueue()
        .then((queue) => {
          console.log('Processing items from the queue:', queue);
          // Implement logic to send queued items to the server
          // Example: queue.forEach(item => sendToServer(item));
        })
        .catch((error) => {
          console.error('Error processing items from the queue:', error);
        });

      // Serve assets from the cache when offline
      event.respondWith(
        caches.match(event.request).then((response) => {
          return response;
        })
      );
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });
}
